import api from 'api';
import { createSlice } from '@reduxjs/toolkit';
import { Dispatch } from 'redux';
import { IGetUserAPIParams } from './userSlice';
import { convertDropdownList } from 'helpers/utils';
import { IAddress } from 'helpers/types';

export interface ICompany {
  id: string;
  _id?: string;
  name: string;
  fiscal_number: string;
  activity: string;
  fleet?: string;
  headquarters: IAddress | null;
  other_stations: IAddress[];
  created_date?: string;
}
interface ICompanyState {
  companies: ICompany[];
  companyDetails: null | ICompany;
  totalCount: number;
}
interface ICompanyResponse {
  companyList: ICompany[];
  record_count: number;
}
const initialState: ICompanyState = {
  companies: [],
  companyDetails: null,
  totalCount: 0,
};
const companySlice = createSlice({
  name: 'Administrator Roles',
  initialState: initialState,
  reducers: {
    setCompanies: (state, { payload }: { payload: ICompanyResponse }) => {
      state.companies = [...payload.companyList];
      state.totalCount = payload.record_count;
    },
    setCompanyDetails: (state, { payload }: { payload: ICompany | null }) => {
      state.companyDetails = payload;
    },
  },
});

export const getCompanyList =
  (
    payload: {
      params?: IGetUserAPIParams;
      url?: string;
      searchString?: string;
      offset?: number;
      limit?: number;
    },
    signal?: AbortSignal,
  ) =>
  async (dispatch: Dispatch) => {
    try {
      const { params, searchString, offset, limit } = payload;
      const queryString = `?offset=${offset ?? 0}&limit=${limit ?? 20}${
        searchString ? `&searchString=${encodeURIComponent(searchString)}` : ''
      }`;
      const { data: responseData } = await api.get(`/admin/company/list${queryString}`, {
        params,
        signal,
      });

      dispatch(setCompanies(responseData?.data));
      return Promise.resolve(responseData?.data);
    } catch (error) {
      return Promise.reject(error);
    }
  };
export const AddCompany = (payload: { request: Omit<ICompany, 'id'> }) => async () => {
  try {
    const { request } = payload;
    const { data: responseData } = await api.post('/admin/company', request);
    return Promise.resolve(responseData?.data);
  } catch (error) {
    return Promise.reject(error);
  }
};
export const editCompany =
  (payload: { request: Omit<ICompany, 'id'>; company_id: string }) => async () => {
    try {
      const { request, company_id } = payload;
      const { data: responseData } = await api.post(`/admin/company/${company_id}`, request);
      return Promise.resolve(responseData?.data);
    } catch (error) {
      return Promise.reject(error);
    }
  };
export const removeCompany = (payload: { company_id: string }) => async () => {
  try {
    const { company_id } = payload;
    const { data: responseData } = await api.delete(`/admin/company/${company_id}`);
    return Promise.resolve(responseData?.data);
  } catch (error) {
    return Promise.reject(error);
  }
};
export const { setCompanies, setCompanyDetails } = companySlice.actions;
export default companySlice.reducer;
